import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import React from "react";
import './style.scss'

export default function UserDetailOptionsField(props) {
    function onFieldValueChange(newValue) {
        if (props.onFieldValueChange)
            props.onFieldValueChange(newValue);
    }

    function onClearSelectClicked() {
        if (props.onFieldValueChange)
            props.onFieldValueChange(undefined);
    }

    if (props.isEditEnabled)
        return (
            <div className="user-detail-options-field">
                {
                    props.isRequired && !props.value ?
                        <div className="user-detail-input-required-sign">*</div>
                        :
                        null
                }
                <Select
                    error={props.isError}
                    value={props.value || ""}
                    onChange={e => onFieldValueChange(e.target.value)}
                    displayEmpty
                    className={"user-detail-options-select" + (!props.value ? " user-detail-options-select-empty" : "") + (props.value ? " clear-select-button-visible" : "")}
                >
                    <MenuItem value="" className="user-detail-options-placeholder-item" disabled>
                        {props.displayName}
                    </MenuItem>
                    {
                        props.options.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.displayName}</MenuItem>
                        ))
                    }
                </Select>
                {
                    props.value ?
                        <div className="clear-select-button-wrapper">
                            <IconButton className="clear-select-button"
                                        onClick={onClearSelectClicked}
                                        size="small">
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </div>
                        :
                        null
                }
            </div>
        );

    const foundOption = props.options.find(option => option.value === props.value);

    return (
        <React.Fragment>
            {foundOption ? foundOption.displayName : "error"}
        </React.Fragment>
    );
}